import "./style.css";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { ThemeProvider } from '@mui/material/styles';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { createTheme } from '@mui/material/styles';
export default function Footer() {
  const theme = createTheme({
    palette: {
      primary: {
         
              main: '#FFCD00',
              dark: '#ffcd38',
              contrastText: '#000',
        
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
    <div className="footer">
     
      
    <div className="foot">
        <div className="footLink">
          <a href="tel:52 735 777" className="footer-link">
       
          <PhoneAndroidIcon color="primary" sx={{width:{lg:36,md:'34px',sm:'24px',xs:'20px'}}}/>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100067945710825"
            className="footer-link"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookIcon color="primary" sx={{width:{lg:36,md:'34px',sm:'24px',xs:'20px'}}}/>
          </a>
          <a
            href="https://www.instagram.com/lamascotte_cafe_resto"
            className="footer-link"
            target="_blank"
            rel="noreferrer"
          >
            <InstagramIcon color="primary" sx={{width:{lg:36,md:'32px',sm:'22px',xs:'18px'}}}/>
          </a>
              
    </div>
        <div className="footLink">
       <ol>
       <li><a href="/">Acceuil</a></li>
       <li><a href="/menu">menu</a></li>
        <li><a href="/menu">Le Family Box</a></li>
        <li><a href="/info">info</a></li>
        <li> <a href="https://glovoapp.com/tn/en/sfax/la-mascotte-sfx/" target="_blank" rel="noreferrer"> Commander en ligne</a> </li>
     
       </ol>
      </div>
      </div>
      <div className="foot">
        <h5 style={{ color: "GrayText" }}>
          © 2024, LA MASCOTTE CAFE RESTO, All Rights Reserved.
        </h5>
      </div>
    
    
    </div>
    </ThemeProvider>
  );
}
